// extracted by mini-css-extract-plugin
export default {"NewOrderPage":"NewOrderPage_NewOrderPage__Ekvse"};